/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useContext, useMemo } from 'react';
import { themes, themeType } from '../common/theme-colors';
import { Theme } from '../common/theme.types';
import useBehaviorSubjectState from './rxjs/useSubjectState';
import { sessionSubject } from '../state/sessionObservable';

export interface ThemeProviderProps {
  children: React.ReactNode;
}

export interface ThemeContextValue {
  colors: themeType;
  activeTheme: Theme;
}

export const ThemeContext = createContext<ThemeContextValue>({
  colors: themes.light,
  activeTheme: Theme.LIGHT,
});

const resolveTheme = (raw: string | undefined | null): Theme => {
  return raw?.toLowerCase() === Theme.DARK ? Theme.DARK : Theme.LIGHT;
};

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const { value: session } = useBehaviorSubjectState(sessionSubject);
  const activeTheme = resolveTheme(
    session?.device?.deviceProfile?.customerDisplay?.theme,
  );

  const value = useMemo(
    () => ({
      colors: themes[activeTheme],
      activeTheme,
    }),
    [activeTheme],
  );

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};

export function useTheme(): ThemeContextValue {
  return useContext(ThemeContext);
}
